// Central content + assets for SuhaniEdge (editable placeholders where noted)

export const IMG = {
  heroAbstract: "https://static.prod-images.emergentagent.com/jobs/fca721d7-307b-4078-8430-76a1d31adb99/images/f7de39db057e9b96d1d29d50ca2a736c0e68d18ac40a960f7a5aa3a22433f3a2.jpeg",
  orb: "https://static.prod-images.emergentagent.com/jobs/fca721d7-307b-4078-8430-76a1d31adb99/images/ca52d44f94f7d09c4fd4115b2603f54d8868b812b6e5d5f939861ae1b442cf72.jpeg",
  founder: "https://static.prod-images.emergentagent.com/jobs/fca721d7-307b-4078-8430-76a1d31adb99/images/f4b692796d45325c07f12b239be91841e5ead391e9650a9e98cb715c5eede0ab.jpeg",
  workshop: "https://images.unsplash.com/photo-1758691736067-b309ee3ef7b9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  desk: "https://images.unsplash.com/photo-1650661926447-9efb2610f64c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  c1: "https://images.unsplash.com/photo-1610716632061-f76783ec35c9?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  c2: "https://images.unsplash.com/photo-1782069326883-090221bfcd6e?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  c3: "https://images.unsplash.com/photo-1610716632424-4d45990bcd48?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  t1: "https://images.unsplash.com/photo-1710438399422-2fca27686bcd?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  t2: "https://images.unsplash.com/photo-1637946175559-22c4fe13fc54?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  logo: "https://customer-assets-0z36b82j.emergentagent.net/job_suhani-ai-academy/artifacts/0smdg1xi_Suhaniedge%20logo%20only.jpeg",
  students: "https://customer-assets-0z36b82j.emergentagent.net/job_suhani-ai-academy/artifacts/i2qw7o89_Suhani%20Edge%20Ai%20Academy%20students.jpeg",
  starterKit: "https://customer-assets-0z36b82j.emergentagent.net/job_suhani-ai-academy/artifacts/5h8b7v51_starter_kit_cover.jpg",
  courseFreelance: "https://static.prod-images.emergentagent.com/jobs/fca721d7-307b-4078-8430-76a1d31adb99/images/159f45da2c45fc0ff4b4d1407e4074e3e1c53fe161d0682861353c64c3d0b7cc.jpeg",
  courseAutomation: "https://static.prod-images.emergentagent.com/jobs/fca721d7-307b-4078-8430-76a1d31adb99/images/a75268ad9a44d8913cd11c9b1aca9e1fdbc1276df4c6f29ec6a9f031a423fd89.jpeg",
  courseIncome: "https://static.prod-images.emergentagent.com/jobs/fca721d7-307b-4078-8430-76a1d31adb99/images/7487dfecb50de9364ffda95fc14447f9710488a80d19783244d5ee7804e53aa4.jpeg",
  courseFilm: "https://static.prod-images.emergentagent.com/jobs/fca721d7-307b-4078-8430-76a1d31adb99/images/be5273df87abdb2558c19e0b9b8cd3dc24a5864e43b25d733f1d028ee890d50c.jpeg",
  courseMarketing: "https://static.prod-images.emergentagent.com/jobs/fca721d7-307b-4078-8430-76a1d31adb99/images/21fb0960e5a7f3520b381c286f53b38d12986a03acf31145db780efe6a159812.jpeg",
  courseBusiness: "https://static.prod-images.emergentagent.com/jobs/fca721d7-307b-4078-8430-76a1d31adb99/images/078ec5d336fe0a2cc6533f8372656aa5c294dc074d73ab9d66c796d91934af8a.jpeg",
};

export const VIDEOS = [
  { src: "https://customer-assets-0z36b82j.emergentagent.net/job_suhani-ai-academy/artifacts/mjyp17jp_sarita%20testimonial%20.mp4", name: "Sarita", program: "SuhaniEdge Student" },
  { src: "https://customer-assets-0z36b82j.emergentagent.net/job_suhani-ai-academy/artifacts/difh534t_sarita%27s%20sister%20testimonial%20.mp4", name: "Sarita's Sister", program: "SuhaniEdge Student" },
  { src: "https://customer-assets-0z36b82j.emergentagent.net/job_suhani-ai-academy/artifacts/25b38ulv_white%20chunni%20girl%20testimonial%20.mp4", name: "SuhaniEdge Student", program: "Verified Review" },
  { src: "https://customer-assets-0z36b82j.emergentagent.net/job_suhani-ai-academy/artifacts/akyknxrn_tile%20man%20testimonial.mp4", name: "SuhaniEdge Student", program: "Verified Review" },
  { src: "https://customer-assets-0z36b82j.emergentagent.net/job_suhani-ai-academy/artifacts/j0q0n8p5_sky%20man%20testimonial%20.mp4", name: "SuhaniEdge Student", program: "Verified Review" },
  { src: "https://customer-assets-0z36b82j.emergentagent.net/job_suhani-ai-academy/artifacts/c2w69dhl_bald%20man%20testimonial%20.mp4", name: "SuhaniEdge Student", program: "Verified Review" },
];

// External links (editable). WhatsApp community invite is a placeholder — replace WHATSAPP with your real group invite link.
export const LINKS = {
  blog: "https://suhaniedge.blogspot.com/",
  freeIncomeKit: "https://superprofile.bio/lf/6a4273e762201e0013e36fe7",
  connect: "https://superprofile.bio/lf/6a8c1986aef03d0013c96dd4",
  store: "https://superprofile.bio/suhaniedge",
  whatsapp: "https://whatsapp.com/channel/0029VbCb1q1AInPonMUCLQ3d",
};

export const AI_TOOLS = [
  { name: "Emergent", domain: "emergent.sh" },
  { name: "Claude", domain: "claude.ai" },
  { name: "Antigravity", domain: "antigravity.google" },
  { name: "Lovable", domain: "lovable.dev" },
  { name: "Gamma", domain: "gamma.app" },
  { name: "Google Flow", domain: "labs.google" },
  { name: "Veo", domain: "deepmind.google" },
  { name: "ChatGPT", domain: "openai.com" },
  { name: "Midjourney", domain: "midjourney.com" },
  { name: "Runway", domain: "runwayml.com" },
  { name: "ElevenLabs", domain: "elevenlabs.io" },
  { name: "Perplexity", domain: "perplexity.ai" },
  { name: "Sora", domain: "sora.com" },
  { name: "Gemini", domain: "gemini.google.com" },
];

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Academy", href: "#academy" },
  { label: "Courses", href: "#courses" },
  { label: "Coaching", href: "#coaching" },
  { label: "Workshops", href: "#workshops" },
  { label: "About", href: "#about" },
  { label: "Resources", href: "#resources" },
];

export const AUDIENCES = [
  { icon: "Sparkles", title: "Beginners", desc: "Start learning AI without getting overwhelmed by technical jargon." },
  { icon: "Palette", title: "Creators", desc: "Create better content, images, videos and ideas with AI." },
  { icon: "Briefcase", title: "Professionals", desc: "Use AI to improve productivity and modernize workflows." },
  { icon: "Rocket", title: "Entrepreneurs", desc: "Apply AI to research, marketing, content and business operations." },
  { icon: "Laptop", title: "Freelancers", desc: "Develop practical AI workflows and service capabilities." },
  { icon: "GraduationCap", title: "Educators", desc: "Use AI for teaching, content creation and productivity." },
];

export const METHOD = [
  { step: "01", title: "Learn", desc: "Understand the concept." },
  { step: "02", title: "Practice", desc: "Experiment with real AI tools." },
  { step: "03", title: "Build", desc: "Create practical projects." },
  { step: "04", title: "Apply", desc: "Use the skill in real-world situations." },
];

export const ACADEMY_CATEGORIES = [
  "Generative AI", "AI Tools", "Prompt Engineering", "AI Image Generation",
  "AI Video Generation", "AI Content Creation", "AI Automation",
  "AI for Digital Marketing", "AI Productivity", "AI for Business",
];

export const COURSES = [
  { img: IMG.courseFreelance, category: "Freelancing", title: "AI Freelance Launchpad Challenge", desc: "Launch a profitable AI-powered freelance service, step by step.", level: "Advanced", duration: "TBD", price: "Price TBD", soon: false, live: true },
  { img: IMG.courseAutomation, category: "AI Automation", title: "AI Automation Mastery", desc: "Automate real workflows and save hours with modern AI tools.", level: "Intermediate", duration: "TBD", price: "Price TBD", soon: false },
  { img: IMG.courseIncome, category: "AI Income", title: "AI Income Mastery", desc: "Build practical AI skills you can turn into real income streams.", level: "All levels", duration: "TBD", price: "Price TBD", soon: false },
  { img: IMG.courseFilm, category: "Generative AI", title: "Generative AI & AI Film Making", desc: "Create images, video and AI films from concept to final cut.", level: "Intermediate", duration: "TBD", price: "Price TBD", soon: false },
  { img: IMG.courseMarketing, category: "Digital Marketing", title: "AI for Digital Marketing", desc: "Apply AI to research, content, campaigns and growth.", level: "All levels", duration: "TBD", price: "Price TBD", soon: false },
  { img: IMG.courseBusiness, category: "Business", title: "AI Business Launchpad", desc: "Launch and grow a modern AI-powered business from scratch.", level: "All levels", duration: "TBD", price: "Price TBD", soon: false },
];

export const WORKSHOPS = [
  { title: "Generative AI Masterclass", soon: false },
  { title: "AI Content Creation", soon: false },
  { title: "AI Video Creation", soon: true },
  { title: "AI Automation", soon: true },
  { title: "AI for Digital Marketing", soon: true },
  { title: "AI Productivity", soon: true },
];

export const COACHING_AREAS = [
  "AI learning roadmap", "AI tools", "Content creation", "AI workflows",
  "Digital growth", "Creator strategy", "AI productivity",
];

export const CORPORATE_TOPICS = [
  "AI fundamentals", "Generative AI", "AI productivity",
  "AI content workflows", "AI automation concepts", "AI for marketing",
];

export const KNOWLEDGE_CATEGORIES = [
  "AI Basics", "AI Tools", "Generative AI", "AI Content Creation",
  "AI Automation", "Digital Marketing", "AI Productivity", "AI Careers",
];

export const FAQS = [
  { q: "What is SuhaniEdge?", a: "SuhaniEdge is a practical AI education brand founded by Suhani Singh, helping learners understand and apply Generative AI, AI tools, content creation, automation and digital growth through courses, workshops and coaching." },
  { q: "Who founded SuhaniEdge?", a: "SuhaniEdge was founded by Suhani Singh, an AI and digital marketing trainer." },
  { q: "What does SuhaniEdge teach?", a: "SuhaniEdge teaches Generative AI, AI tools, prompt engineering, AI image and video generation, AI content creation, AI automation concepts, digital marketing and SEO." },
  { q: "Who is SuhaniEdge for?", a: "It is for beginners, creators, professionals, entrepreneurs, freelancers and educators who want to understand and apply AI practically." },
  { q: "What is Generative AI?", a: "Generative AI refers to AI systems that create new content such as text, images, audio and video based on the data they were trained on and the prompts they are given." },
  { q: "Do I need technical knowledge to learn AI?", a: "No. SuhaniEdge is designed to make AI understandable for non-technical learners, starting from the fundamentals." },
  { q: "Does SuhaniEdge offer AI courses?", a: "Yes. SuhaniEdge offers practical AI courses. Available courses are listed in the Courses section, with more marked Coming Soon." },
  { q: "Does SuhaniEdge offer coaching?", a: "Yes. Personalized coaching is available for learners who want a tailored roadmap, feedback and implementation support." },
  { q: "Does SuhaniEdge offer workshops?", a: "Yes. SuhaniEdge runs practical, hands-on workshops. Upcoming sessions are marked Coming Soon." },
  { q: "Does SuhaniEdge offer corporate training?", a: "Yes. SuhaniEdge can provide practical AI education for organizations, teams and educators." },
  { q: "Who is Suhani Singh?", a: "Suhani Singh is the founder of SuhaniEdge and an AI and digital marketing trainer focused on practical, accessible education. She has taught 1,200+ students." },
  { q: "How can I enroll in a SuhaniEdge course?", a: "Browse the Courses section and choose View Course, or get started with the free AI Starter Kit to receive updates on enrollments." },
];

export const SOCIALS = [
  { label: "Instagram", icon: "Instagram", href: "https://www.instagram.com/suhaniedge" },
  { label: "YouTube", icon: "Youtube", href: "https://youtube.com/@suhaniedge" },
  { label: "LinkedIn", icon: "Linkedin", href: "https://www.linkedin.com/in/suhanisingh10" },
  { label: "Pinterest", icon: "Pin", href: "https://pin.it/3EvewzsLd" },
];
